import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {XhAnonymizePage} from "../page/overview/anonymize/xh-anonymize.page";


const xhModuleEntry: TestModuleDefinition = {
    key: 'xh',
    label: 'Anonymization (xh)',
    components: [
        {
            key: 'XhAnonymizePage',
            component: XhAnonymizePage,
            selector: 'mvs-xx-table-page',
            type: 'PageComponent',
            label: 'xh anonymize page'
        },
    ]
}

export const XH_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: xhModuleEntry, multi: true}
];